import {
  createPeekContent,
  PaymentSummaryContent,
} from "@/components/shared/relationships/peek-content";
import { registerPeekType } from "@/components/shared/relationships/peek-registry";
import { useVendorPayment } from "@/features/vendor-payments/hooks/use-vendor-payments";

function VendorPaymentContent({
  payment,
}: {
  payment: NonNullable<ReturnType<typeof useVendorPayment>["data"]>;
}) {
  return (
    <PaymentSummaryContent
      payment={{
        accountId: payment.account_id,
        accountName: payment.gl_accounts?.name,
        amount: payment.amount,
        date: payment.date,
        id: payment.id,
        method: payment.method,
        reference: payment.reference,
        targetId: payment.purchase_order_id,
        targetLabel: "Purchase Order",
        targetName: payment.gl_purchase_orders?.uid,
        targetType: "purchase-order",
        uid: payment.uid,
      }}
    />
  );
}

/** Vendor-payment quick-view content, registered on import via `src/app/peek-registrations.ts`. */
export const VendorPaymentPeekContent = createPeekContent({
  emptyMessage: "No payment found",
  render: (payment) => <VendorPaymentContent payment={payment} />,
  useDetail: useVendorPayment,
});

registerPeekType("vendor-payment", VendorPaymentPeekContent);
